import { convertToRaw } from "draft-js";
import { FaCompany, FaUser } from "../assets/Images/icon";

export function N_hours_from_minutes(nhours) {
  return nhours / 60;
}

const oneMinute = 60 * 1000;

export const getTimeAfterNumberOfMinutes = (startDateTimeValue, n) => {
  // Step 1: Get the time in milliseconds after adding n minutes
  const date = new Date(new Date(startDateTimeValue).getTime() + n * oneMinute);

  // Step 2: Set seconds and milliseconds to 0 to ensure it ends on the exact minute
  date.setSeconds(0);
  date.setMilliseconds(0);

  return date;
};

// convert seconds into days, hours, minutes
export const formatTime = (seconds) => {
  // Convert seconds to days, hours, and minutes
  const days = Math.floor(seconds / (3600 * 24));
  const hours = Math.floor((seconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  // Construct the formatted string
  let formattedString = "";
  if (days > 0) {
    formattedString += `${days} day${days === 1 ? "" : "s"}`;
  }
  if (hours > 0) {
    formattedString += `${formattedString ? "  " : ""}${hours} hour${hours === 1 ? "" : "s"
      }`;
  }
  if (minutes > 0 || (days === 0 && hours === 0)) {
    formattedString += `${formattedString ? "  " : ""}${minutes} minute${minutes === 1 ? "" : "s"
      }`;
  }

  if (minutes == 0 && days == 0 && hours == 0) {
    return `${seconds} second${seconds === 1 ? "" : "s"}`;
  }

  // Return the formatted string
  return formattedString;
};

//constructing the query string based on the search parameters
const constructQueryString = (params, keys) => {
  return keys
    .map((key) =>
      params.get(key) !== null ? `${key}=${params.get(key)}&` : ""
    )
    .join("");
};

// hotdealKeys(Search parameters) keys
export const getHotdealUrl = (searchParams) => {
  const hotdealKeys = [
    "ae_country_id",
    "ae_seller_allowed",
    "ae_display_for",
    "ae_product_type_id",
    "ae_recurring",
    "ae_sort",
    "ae_start_day",
    "ae_end_day",
    "ae_keyword",
    "ae_per_page",
    "ae_page",
    "hotdeal_page",
  ];
  const defaultKeys = [
    "a_country_id",
    "a_seller_allowed",
    "a_display_for",
    "a_product_type_id",
    "a_status",
    "a_sort",
    "a_keyword",
    "a_per_page",
    "a_page",
  ];

  //returning navigate back path with applied filters(search parameters)
  const hotdealId = searchParams.get("hotdeal_id");
  if (hotdealId !== null) {
    return `/hotdeals/${hotdealId}?${constructQueryString(
      searchParams,
      hotdealKeys
    )}`;
  } else {
    return `/hotdeals?${constructQueryString(searchParams, defaultKeys)}`;
  }
};

// auctionKeys(Search parameters) keys
export const getAuctionUrl = (searchParams) => {
  const auctionKeys = [
    "ae_country_id",
    "ae_seller_allowed",
    "ae_display_for",
    "ae_product_type_id",
    "ae_recurring",
    "ae_sort",
    "ae_start_day",
    "ae_end_day",
    "ae_keyword",
    "ae_per_page",
    "ae_page",
    "auction_page",
  ];
  const defaultKeys = [
    "a_country_id",
    "a_seller_allowed",
    "a_display_for",
    "a_product_type_id",
    "a_status",
    "a_sort",
    "a_keyword",
    "a_per_page",
    "a_page",
  ];

  //returning navigate back path with applied filters(search parameters)
  const auctionId = searchParams.get("auction_id");
  if (auctionId !== null) {
    return `/auction/${auctionId}?${constructQueryString(
      searchParams,
      auctionKeys
    )}`;
  } else {
    return `/auctions?${constructQueryString(searchParams, defaultKeys)}`;
  }
};

//generating query params
export const generateQueryString = (params) => {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== "" && value !== undefined && value !== null) {
      queryParams.append(key, value);
    }
  });

  return queryParams.toString();
};

//helper function to truncate the text to n words.
export const truncateText = (text, charLimit) => {
  if (text.length > charLimit) return text.substring(0, charLimit) + "...";
  return text;
};

//function to check the text overflow status and ellipsis in column (boolean value)
export const getOverflowState = (refs) => {
  const newOverflowStates = {};
  Object.keys(refs).forEach((key) => {
    const ref = refs[key];
    if (ref) {
      const isTextOverflowing = ref.scrollWidth > ref.clientWidth;
      newOverflowStates[key] = isTextOverflowing;
    }
  });
  return newOverflowStates;
};

export const constructQueryStringFromIds = (ids, paramName) => {
  return ids.map((id, index) => `${paramName}[${index}]=${id}`).join("&");
};

// Common function to format currency with Euro sign before the numbers
export const formatCurrency = (amount, returnNumericValue = false) => {
  if (amount === undefined || amount === null) return "-";

  const numericAmount = parseFloat(amount);
  if (isNaN(numericAmount)) return "-";

  if (returnNumericValue) {
    // Return a plain numeric value (e.g., 123.45)
    return (numericAmount / 100).toFixed(2);
  }

  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  // Format the number and manually add the Euro sign at the beginning
  return `€ ${formatter
    .format(numericAmount / 100)
    .replace("€", "")
    .trim()}`;
};

// Reusable component for displaying formatted currency
export const CurrencyDisplay = ({ amount, title }) => {
  return <b title={title || "Amount"}>{formatCurrency(amount)}</b>;
};

export const CountriesLists = async () => {
  let getCountries = JSON.parse(localStorage.getItem("countries") || "{}");
  if (getCountries.length > 0) {
    return getCountries;
  }
};

export const getProductTypeName = (productId) => {
  const products = JSON.parse(localStorage.getItem("productType"));
  if (products && products.length > 0) {
    const product = products.find((product) => product.id === productId);
    if (product) {
      return product.item_name.en;
    }
  }
  return "-";
};

export const getActiveLanguages = () => {
  const languages = JSON.parse(localStorage.getItem("languages") || "{}");
  if (languages) {
    return languages;
  }
  return [];
};

export const convertToIdNameFormat = (data) => {
  return data.reduce((acc, item) => {
    acc[item.id] = item.name;
    return acc;
  }, {});
};

export const checkForSuperAdmin = () => {
  const isSuperAdmin = JSON.parse(localStorage.getItem("is_superadmin"));
  return isSuperAdmin ?? false;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const APIError = (error) => {
  const resp = error.response;
  if (
    !resp ||
    resp.data == null ||
    typeof resp.data !== "object" ||
    Array.isArray(resp.data)
  ) {
    return error.message || "Network error";
  }
  // Laravel's debug renderer (APP_DEBUG=true) returns the raw exception, SQL included; never surface it.
  if (resp.data && typeof resp.data === "object" && "exception" in resp.data) {
    return "Something went wrong. Please try again.";
  }
  let error_message = "";
  if (resp.data.data !== undefined && resp.data.data !== null) {
    {
      Object.keys(resp.data?.data).map(
        (error, index) => (error_message = resp.data.data[error][0])
      );
    }
  } else if (resp.data.data?.error !== undefined) {
    error_message = resp.data.data.error;
  } else if (resp.data?.error !== undefined) {
    error_message = resp.data.error;
  } else {
    error_message = resp.data.message;
  }
  return error_message || error.message || "Network error";
};

export const downloadFileError = async (error) => {
  const resp = error.response;

  let error_message = "Something went wrong!";

  if (resp && resp.data instanceof Blob) {
    try {
      // Convert Blob to JSON
      const text = await resp.data.text();
      const json = JSON.parse(text);

      if (json.errors) {
        error_message = Object.values(json.errors)[0][0] || error_message;
      } else if (json.data?.error) {
        error_message = json.data.error;
      } else if (json.error) {
        error_message = json.error;
      } else {
        error_message = json.message || error_message;
      }
    } catch (err) { }
  } else if (resp?.data?.message) {
    error_message = resp.data.message;
  }
  return error_message;
};

export const removeUnderscoreAndCapitalize = (str) => {
  return str
    .split("_")
    .map((word) => capitalizeFirstLetter(word))
    .join(" ");
};

export const extractPlainTextFromHTML = (editorState) => {
  if (!editorState) return "";
  const blocks = convertToRaw(editorState.getCurrentContent()).blocks;
  return blocks
    .map((block) => (!block.text.trim() && "\n") || block.text)
    .join("\n")
    .trim();
};

export const isCurrentTimeGreater = (targetTime) => {
  const now = new Date();
  const target = new Date(targetTime);

  return now > target;
};

export const showUserTypeBadge = (source) => {
  if (source === "subsidiary") return <FaCompany className="profileIcon" />;
  return <FaUser className="profileIcon" />;
};

export const getUserName = (user) => {
  if (!user) return "-";
  const firstName = user.first_name || "";
  const lastName = user.last_name || "";
  const pseudoName = user.pseudo || "";

  if (firstName || lastName) {
    return `${firstName} ${lastName}`.trim();
  } else if (pseudoName) {
    return pseudoName;
  } else {
    return "-";
  }
}
